import apiClient from './authService';

/**
 * WhatsApp Flow definitions synced from Meta (customer-scoped).
 */
export const flowSyncService = {
  /** POST /customers/flows/sync — list/metadata only */
  syncFlows: async () => {
    const response = await apiClient.post('/customers/flows/sync');
    return response.data;
  },

  /** POST /customers/flows/definitions/:metaFlowId/fetch-json — assets + CDN download */
  fetchFlowJson: async (metaFlowId) => {
    const encoded = encodeURIComponent(metaFlowId);
    const response = await apiClient.post(`/customers/flows/definitions/${encoded}/fetch-json`);
    return response.data;
  },

  /** GET /customers/flows/definitions */
  listFlowDefinitions: async () => {
    const response = await apiClient.get('/customers/flows/definitions');
    return response.data;
  },

  /** POST /customers/flows/validate-routing?flowId= */
  validateRouting: async (flowId) => {
    const response = await apiClient.post(
      '/customers/flows/validate-routing',
      null,
      { params: { flowId } }
    );
    return response.data;
  },
};

export default flowSyncService;
